<template>
    <div class="cs-userContentComponent">
      <DefaultComponent :dictionary="dictionary" 
      v-if="steps.isFormStep"
      :isDefaultService="false" :offer="offer" 
      @closeComponent="$emit('closeComponent')" @goToNextStep="scrapeUser"
      :injectedError="steps.error" :inputFieldValue="userInfo.username"
      ></DefaultComponent>
      <LoaderComponent v-if="steps.isLoading"></LoaderComponent>
      <div class="cs-userContentComponent__content cs-formBoxContainer" v-if="steps.isShowContentStep">
        <DefaultHeader :offer="offer" @closeComponent="$emit('closeComponent')"></DefaultHeader>
        <div class="cs-userContentComponent__serviceInstruction cs-subtitle">
          {{getServiceInstruction()}} {{offer.serviceQuantity}} {{ offer.serviceName}}
        </div>
        <div class="cs-userContentComponent__errorMessage cs-fieldErrorMessage" v-if="error.value">
          {{error.message}}
        </div>
        <div :class="getClassForContent()">
          <div class="cs-userContentComponent__contentItemContainer" :class="getClassForContentItem()" 
          v-for="content of userInfo.medias" v-bind:key="content.shortcode" v-on:click="addOrRemoveItemToSelectedMedia(content)">
            <img :src="getContentImage(content)" :class="getClassForContentItem()">
            <div class="cs-userContentComponent__contentItemCover" v-if="isMediaInSelectedMedia(content)">
              <img :src="getServiceIconURL()" alt="" class="cs-userContentComponent__serviceIcon">
              <div class="cs-userContentComponent__serviceQuantity">+{{offer.serviceQuantity}}</div>
            </div>
          </div>
        </div>
        <div class="cs-userContentComponent__contentUsername">{{userInfo.username}}</div>
        <div class="cs-userContentComponent__contentUsernameQuestion" v-on:click="onWrongUsernameClick()">{{dictionary.wrongUsernameChangeIt}}</div>
        <div class="cs-userContentComponent__servicePriceContainer">
          <span class="cs-userContentComponent__servicePriceLabel">{{dictionary.alreadyDiscountedPrice}}</span>
          <span class="cs-userContentComponent__servicePriceLabel">{{getServicePrice()}} €</span>
        </div>
        <div class="cs-userContentComponent__addToCart cs-formSubmitButton" v-on:click="onSubmit()">
          {{dictionary.buyNowTheOffer}}
        </div>
      </div>
      <OfferAddedToCart :dictionary="dictionary" :isShown="steps.isAddToCartSuccess" @closeComponent="$emit('closeComponent')"></OfferAddedToCart>
      <UserPrivateComponent :isUserPrivate="userInfo.isPrivate" :offer="offer" :dictionary="dictionary" :user="userInfo" 
      @closeComponent="$emit('closeComponent')" @onWrongUsername="returnToFormStep()"  @retry="scrapeUser" @cancel="resetForm()"></UserPrivateComponent>
      <UserNotFoundComponent :isUserNotFound="steps.isUserNotFound" :dictionary="dictionary" 
      :user="userInfo" :offer="offer" @closeComponent="$emit('closeComponent')"
      @resetForm="resetForm()" @addToCart="onSubmit()"></UserNotFoundComponent>
      <div class="cs-userContentComponent__errorNotFound"></div>
    </div>
  </template>
  <script>
import { API2, SERVICE_TYPE, API, INSTAGRAM_POST_LINK } from '@/assets/js/constants';
import DefaultComponent from './DefaultComponent.vue';
import LoaderComponent from './LoaderComponent.vue';
import UserPrivateComponent from './UserPrivateComponent.vue';
import UserNotFoundComponent from './UserNotFoundComponent.vue';
import OfferAddedToCart from './OfferAddedToCart.vue';
import DefaultHeader from './DefaultHeader.vue';
import {formatQuantityToLocale} from '@/assets/js/formatUtils.js';
import {addToCart} from '@/assets/js/formUtils.js';
import axios from 'axios';
  export default {
    name: 'UserContentComponent',
    props: ["offer", "dictionary"],
    emits: ["closeComponent"],
    components: { DefaultComponent, LoaderComponent, UserPrivateComponent, OfferAddedToCart, UserNotFoundComponent, DefaultHeader},
    data: function(){
      return {
        userInfo: {
          profilePic:"",
          medias: [],
          isSingleMedia: false,
          singleMedia: null,
          selectedMedias: [],
          isPrivate: false,
          username: "",
        },
        steps:{
          isLoading: false,
          isFormStep: true,
          isShowContentStep: false,
          isUserNotFound: false,
          isMediaNotFound: false,
          isAfterAddToCart: true,
          error: {
            value: false,
            message: ""
          }
        },
        error: {
          value: false,
          message: ""
        }
      }
    },
    methods: {
      formatQuantityToLocale: formatQuantityToLocale,
      formatPriceToLocale(price){
        return price.toLocaleString('it-IT', {minimumFractionDigits: 2});
      },
      async scrapeUser(username){
        this.resetUserInfo();
        this.userInfo.username = username;
        this.resetErrors();
        this.toggleLoading();
        this.steps.isFormStep = false;
          if((this.offer.sliderID == SERVICE_TYPE.igPhoto || this.offer.sliderID == SERVICE_TYPE.igVideo ) && this.isInstagramPostOrVideoURL(username)){
            await this.scrapeIgMedia(this.getShortcodeFromInstagramPostOrVideoURL(username));
          } else if (this.offer.sliderID == SERVICE_TYPE.igPhoto || this.offer.sliderID == SERVICE_TYPE.igVideo ){
            await this.scrapeIgUserFeed(username);
          } else if (this.offer.sliderID == SERVICE_TYPE.tkVideo){
            await this.scrapeTkUserFeed(username);
          }
        this.toggleLoading();
        if(!this.steps.isUserNotFound && !this.userInfo.isPrivate && !this.steps.isMediaNotFound){
          this.toggleShowContentStep();
          if(!this.userInfo.isSingleMedia){
            setTimeout(() => {
            this.setSlidingContent();
          }, 400);
          }
        } else if(this.steps.isMediaNotFound){
          this.toggleFormStep();
        }
      },
      async scrapeIgUserFeed(username){
        return axios.post(API2.url + API2.igUserEndpoint, {
          user: username
        }).then(res => {
          if(this.isUserNotFound(res.data)){
            this.toggleUserNotFound();
          } else {
            this.fillUserInfo(res.data.username, res.data.profilePic, res.data.medias, res.data.isPrivate);
            if(!this.userHasMedias(res.data.medias)){
              this.toggleNoMediasFound();
            }
          }
        })
      },
      async scrapeIgMedia(shortcode){
        return axios.post(API2.url + API2.igMediaEndpoint, {
          user: shortcode
        }).then(res => {
          if(this.isUserNotFound(res.data)){
            this.toggleUserNotFound();
          } else {
            this.fillUserInfo(res.data.username, res.data.profilePic, res.data.medias, res.data.isPrivate);
            if(!this.userHasMedias(res.data.medias)){
              this.toggleNoMediasFound();
            }
          }
        })
      },
      async scrapeTkUserFeed(username){
        try {
          const tkUser = await axios.post(API2.url + API2.tkUserEndpoint, {
            user: username
          });
          if(this.isUserNotFound(tkUser.data)){
            this.toggleUserNotFound();
          } else {
            this.fillUserInfo(tkUser.data.username, tkUser.data.avatar, [], tkUser.data.isPrivate);
            if(!this.isUserPrivate(tkUser.data)){
              return axios.post(API2.url + API2.tkUserFeed, {
              user: username
              }).then(res2 => {
                if(!!res2.data && !!res2.data.videos && this.userHasMedias(res2.data.videos)){
                  this.fillUserInfo(tkUser.data.username, tkUser.data.avatar, res2.data.videos, tkUser.data.isPrivate);
                } else {
                  this.toggleNoMediasFound();
                }
              })
            }
          }
        } catch (err){
          console.log(err);
        }
      },
      addOrRemoveItemToSelectedMedia(item){
        if(this.isMediaInSelectedMedia(item)){
          this.userInfo.selectedMedias.splice(this.userInfo.selectedMedias.indexOf(item), 1);
        } else {
          this.userInfo.selectedMedias.push(item);
        }
      },
      isMediaInSelectedMedia(item){
        return this.userInfo.selectedMedias.includes(item);
      },
      getServicePrice(){
        const nSelectedMedias = this.userInfo.selectedMedias.length > 0 ? this.userInfo.selectedMedias.length : 1;
        return this.formatPriceToLocale(Number.parseFloat(this.offer.discountedPrice.replace(',','.'))  * nSelectedMedias);
      },
      resetUserInfo(){
        this.userInfo = {
          profilePic:"",
          medias: [],
          isSingleMedia: false,
          singleMedia: null,
          selectedMedias: [],
          isPrivate: false,
          username: "",
        }
      },
      getSelectedMediaLinks(){
        if(this.offer.sliderID == SERVICE_TYPE.igPhoto || this.offer.sliderID == SERVICE_TYPE.igVideo){
          return this.userInfo.isSingleMedia ? [INSTAGRAM_POST_LINK + this.singleMedia.shortcode] : this.userInfo.selectedMedias.map(item => INSTAGRAM_POST_LINK + item.shortcode);
        } else if (this.offer.sliderID == SERVICE_TYPE.tkVideo){
          return this.userInfo.selectedMedias.map(item => item.videoUrl);
        }
      },
      getSelectedMediaInitialQuantities(){
        if(this.offer.sliderID == SERVICE_TYPE.igPhoto || this.offer.sliderID == SERVICE_TYPE.igVideo){
          return this.userInfo.isSingleMedia ? [this.userInfo.singleMedia[this.offer.serviceFeatures.statisticName]] : this.userInfo.selectedMedias.map(item => item[this.offer.serviceFeatures.statisticName]);
        } else if (this.offer.sliderID == SERVICE_TYPE.tkVideo){
          return this.userInfo.selectedMedias.map(item => item[this.offer.serviceFeatures.statisticName]);
        }
      },
      resetErrors(){
        this.steps.isUserNotFound = false;
        this.steps.isMediaNotFound = false;
        this.steps.error.value = false;
        this.steps.error.message = "";
        this.error.value = false;
        this.error.message = "";
      },
      returnToFormStep(){
        this.resetUserInfo();
        this.resetErrors();
        this.steps.isShowContentStep = false;
        this.toggleFormStep();
      },
      resetForm(){
        this.userInfo = {
          profilePic:"",
          medias: [],
          isSingleMedia: false,
          singleMedia: null,
          selectedMedias: [],
          isPrivate: false,
          username: "",
        }
        this.resetErrors();
        this.toggleFormStep();
      },
      onWrongUsernameClick(){
        this.toggleShowContentStep();
        this.resetForm();
      },
      isUserNotFound(response){
        if(response == {} || response.err) {
          this.steps.userNotFound = true;
          return true;
        }
        return false;
      },
      isUserPrivate(data){
        return data.isPrivate;
      },
      userHasMedias(medias){
        return medias.length > 0;
      },
      getContentSubtitle(){
        if(this.offer.sliderID == SERVICE_TYPE.tkVideo || this.offer.sliderID == SERVICE_TYPE.igVideo){
          return this.dictionary.slideToLeftAndClickTheVideos;
        } else if (this.offer.sliderID == SERVICE_TYPE.igPhoto){
          return this.dictionary.slideToLeftAndClickThePosts;
        }
      },
      toggleUserNotFound(){
        this.steps.isUserNotFound = true;
      },
      toggleNoMediasFound(){
        this.steps.isMediaNotFound = true;
        this.steps.error = {
          value: true,
          message: this.dictionary.noMediaFound
        }
      },
      isInstagramPostOrVideoURL(username){
        return username.includes("instagram.com/p/") || username.includes("instagram.com/tv/") || username.includes("instagram.com/reel/");
      },
      getShortcodeFromInstagramPostOrVideoURL(username){
        const shortcodeRegex = /instagram\.com\/(?:p|tv|reel)\/([A-Za-z0-9\-_]+)/;
        let shortcode = username.match(shortcodeRegex)[1];
        return shortcode;
      },
      fillUserInfo(username, profilePic, medias, isPrivate){
        this.userInfo.username = username;
        this.userInfo.profilePic = profilePic;
        this.userInfo.medias = medias;
        this.userInfo.isPrivate = isPrivate;
      },
      fillSinglemediaInfo(singleMedia){
        this.userInfo.isSingleMedia = true;
        this.userInfo.singleMedia.username = singleMedia.username;
        this.userInfo.singleMedia.shortcode = singleMedia.shortcode;
        this.userInfo.displayUrl = singleMedia.img;
      },
      getClassForContent(){
        if(this.userInfo.isSingleMedia || this.userInfo.medias.length == 1){
          return "cs-userContentComponent__contentSingleItem";
        } else if(this.userInfo.medias.length == 2) {
          return "cs-userContentComponent__contentDoubleItem";
        } else if((this.userInfo.medias.length>= 3 && (this.offer.sliderID == SERVICE_TYPE.igVideo || this.offer.sliderID == SERVICE_TYPE.tkVideo)) ||
         (this.userInfo.medias.length >= 3 && this.userInfo.medias.length <= 5 && this.offer.sliderID == SERVICE_TYPE.igPhoto)){
          return "cs-userContentComponent__contentSingleRow";
        } else if(this.offer.sliderID == SERVICE_TYPE.igPhoto && this.userInfo.medias.length > 5){ 
          return "cs-userContentComponent__contentDoubleRow";
        }
      },
      getClassForContentItem(){
        if(this.offer.sliderID == SERVICE_TYPE.igPhoto){
          return "cs-userContentComponent__contentSquare";
        } else if(this.offer.sliderID == SERVICE_TYPE.igVideo || this.offer.sliderID == SERVICE_TYPE.tkVideo){
          return "cs-userContentComponent__contentRectangle";
        }
      },
      setSlidingContent(){
        if((this.userInfo.medias.length>= 3 && (this.offer.sliderID == SERVICE_TYPE.igVideo || this.offer.sliderID == SERVICE_TYPE.tkVideo)) ||
         (this.userInfo.medias.length >= 3 && this.userInfo.medias.length <= 5 && this.offer.sliderID == SERVICE_TYPE.igPhoto)){
          this.setSlidingRows('.cs-userContentComponent__contentSingleRow');
        } else if(this.offer.sliderID == SERVICE_TYPE.igPhoto && this.userInfo.medias.length > 5){ 
          this.setSlidingRows('.cs-userContentComponent__contentDoubleRow');
        }
      },
      toggleLoading(){
        this.steps.isLoading = !this.steps.isLoading;
      },
      toggleFormStep(){
        this.steps.isFormStep = !this.steps.isFormStep;
      },
      toggleShowContentStep(){
        this.steps.isShowContentStep = !this.steps.isShowContentStep;
      },
      isMediaSelected(media){
        return this.offer.selectedMedia && this.offer.selectedMedia.shortcode == media.shortcode;
      },
      setSlidingRows(className) {
        const slider = document.querySelector(className);
        let isDown = false;
        let startX;
        let scrollLeft;
        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 1.5; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
      },
      getContentImage(content){
        if(this.offer.sliderID == SERVICE_TYPE.igPhoto || this.offer.sliderID == SERVICE_TYPE.igVideo){
          return content.img;
        } else if(this.offer.sliderID == SERVICE_TYPE.tkVideo){
          return content.image;
        } 
      },
      getServiceInstruction(){
        if(this.offer.sliderID == SERVICE_TYPE.igPhoto){
          return this.dictionary.slideToLeftAndClickThePosts;
        } else if( this.offer.sliderID == SERVICE_TYPE.igVideo || this.offer.sliderID == SERVICE_TYPE.tkVideo) {
          return this.dictionary.slideToLeftAndClickTheVideos;
        }
      },
      getServiceIconURL(){
        return API.url + this.offer.serviceFeatures.serviceIcon.path;
      },
      async onSubmit(){
        this.resetErrors();
        if(this.userInfo.selectedMedias.length > 0 || this.userInfo.isSingleMedia){
          this.toggleLoading();
          this.toggleShowContentStep();
          const medialinks = this.getSelectedMediaLinks();
          const initialQuantities = this.getSelectedMediaInitialQuantities();
          let cartHasError = false;
          for(let index = 0; index < medialinks.length; index++){
            await addToCart(this.offer._id, medialinks[index],initialQuantities[index] ? initialQuantities[index] : 'unavailable').then(res=>{
              if(res.data.error){
                cartHasError = true;
                this.toggleLoading();
                this.onAddToCartError();
                this.toggleShowContentStep();
              }
            }).catch(() => {
              cartHasError = true;
              this.toggleLoading();
              this.toggleShowContentStep();
              this.onAddToCartError();
            });
          }
          if(!cartHasError){
              this.toggleLoading();
              this.onAddToCartSuccess();
          }
        } else {
          this.error.value = true;
          this.error.message = this.dictionary.selectAtLeastOneMedia;
        }
      },
      onAddToCartError(){
        this.error.value = true;
        this.error.message = this.dictionary.addToCartError;
      },
      onAddToCartSuccess(){
        this.steps.isAddToCartSuccess = true;
      },
    }
}
  </script>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/form.scss";

    .cs-userContentComponent {
      &__service{
        &Icon{
          width: 25px;
        }

        &Price{
          &Container{
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            font-weight: 600;
            font-size: 14px;
            margin: 10px 0;
          }

          &Label{
            color: #1B6487;
          }

          color: #61CE70;

        }
      }
      &__content {

        &Square{
          width: 120px;
          height: 120px;
          border-radius: 25px;
        }

        &Rectangle{
          width: 110px;
          height: 190px;
          border-radius: 25px;
        }

        &ItemContainer{
          position: relative;
          margin: 5px 5px 0;
          min-width: 120px;
        }

        &ItemCover{
          position: absolute;
          background-color: rgba(50,185,236,.8);
          border-radius: 25px;
          border: 5px solid #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }

        &SingleItem{
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &DoubleItem{
          display: flex;
          justify-content: space-evenly;
          align-items: center;
        }

        &SingleRow{
          display: flex;
          overflow-x: scroll;
          overflow-y: hidden;
          flex-flow: row;
          width: 100%;
          user-select: none;
          scroll-behavior: auto;
          cursor: grab;
          -ms-overflow-style: none;  /* IE and Edge */
          scrollbar-width: none;  /* Firefox */
        }

        &DoubleRow{
          display: flex;
          flex-flow: column wrap;
          width: 100%;
          height: 270px;
          scroll-behavior: auto;
          overflow-y: hidden;
          overflow-x: scroll;
          cursor: grab;
          padding: 0 25px;
          user-select: none;
          max-width: 350px;  
          -ms-overflow-style: none;  /* IE and Edge */
          scrollbar-width: none;  /* Firefox */
        }

        &DoubleRow::-webkit-scrollbar, &SingleRow::-webkit-scrollbar {
          display: none;
        }

        &Username{
          color: #C98CE5;
          font-size: 18px;
          font-weight: 500;
          &Question{
            color: #123F49;
            font-size: 12px;
            font-weight: 400;
            cursor: pointer;
          }
        }
      }

    }
  </style>
